import { toast } from "react-toastify";
import { apiCaller } from "../../middleware/api-caller";
import { getCookie } from "services/session/cookies";
import { setCookie } from "services/session/cookies";
import { logOut } from "utils/helpers/common";
import { REACT_APP_API_BASE_URL } from "../../../utils/constants/constatns";
import { ENDPOINTS, REQUEST_TYPES } from "../../../services/middleware/url";
import {
  GetPermission,
  LoginAction,
  UserTypesAction,
} from "../../../store/actions/Auth";
import { errorMessages, messsageStatusResponse, successMessage } from "utils/helpers";
import {
  ApiRequestedAction,
  ApiFulfilledAction,
  ApiRejectedAction,
} from "../../../store/actions/ApiCallStatus";
import { getData } from "../common";
import { Permissions } from "utils/constants/Permissions/features";
import { handleNavigation, OnlyInclude } from "utils/helpers/common";

export const loginAPI = (
  method,
  url,
  data,
  apiCallFor,
  navigate,
  redirectLink,
  setIsLoading
) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    setIsLoading(true)
    const myJson = await apiCaller({ method, url: url, data });
    setIsLoading(false)
    const user = JSON.stringify(myJson?.data?.data);
    if (
      (myJson && myJson?.data?.statusCode === 200) ||
      myJson?.data?.statusCode === 201
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
      dispatch(LoginAction(myJson?.data?.data));
      setCookie("accessToken", myJson.headers.authorization);
      setCookie("user", user);
      toast.success("Login successfully.");
      const userPermissions =
        (await getData(REQUEST_TYPES.GET, `${ENDPOINTS.GET_USER_PERMISSIONS}`)) ??
        [];
      setCookie("permissions", JSON.stringify(userPermissions));

      const hasOnlySpecifiedPermissions = userPermissions.every(permission => OnlyInclude.includes(permission));

      if (hasOnlySpecifiedPermissions) {
        navigate('/home');
        // handleNavigation(
        //   "B02",
        //   userPermissions.includes(Permissions.DDS_DS)
        //     ? "/dds-dashboard"
        //     : userPermissions.includes(Permissions.INSTORE_DS)
        //       ? "/in-store-dashboard" : "/reporting",
        //   userPermissions,
        //   navigate,
        //   dispatch
        // );
      } else {
        return navigate(redirectLink);
      }
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(errorMessages(message));
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
      if (message === "Account not verified") {
        return navigate("/verify-account");
      }
    }
  };
};

export const RegisterAPI = (method, url, data, apiCallFor, navigate) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url: url, data });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
      toast.success(myJson?.data.message || "Register successfully.");
      return myJson?.data;
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(
        errorMessages(Array.isArray(message) ? message.join(", ") : message)
      );
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
    }
  };
};

export const UpdateItem = (method, url, data, id, apiCallFor, navigate) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url: `${url}/${id}`, data });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
      toast.success("Update successfully.");
      return myJson?.data;
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(errorMessages(message));
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
      return myJson?.data;
    }
  };
};

export const RegisterFieldStaff = (method, url, data, apiCallFor, navigate) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url: url, data });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
      toast.success("Register successfully.");
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(errorMessages(message));
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
    }
  };
};

export const CreateUser = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: url, data });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
  ) {
    const { data } = myJson;
    if (data?.data) {
      toast.success("Information stored successfully.");
      return data?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};

export const deleteItem = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: `${url}/${data}` });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
  ) {
    const { data } = myJson;
    if (data?.data) {
      toast.success("Information Delete successfully.");
      return myJson?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};

export const verifyAccount = async (
  method,
  url,
  data,
  apiCallFor,
  navigate,
  redirectLink
) => {
  const myJson = await apiCaller({ method, url: `${url}${data}` });
  try {
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      const { data } = myJson;
      const message = myJson?.response?.data?.message ?? "Account verified Successfully";
      toast.success(message);
      navigate(redirectLink);
      return;
    } else if (myJson?.data?.statusCode === 400) {
      // Handle token expiration
      toast.error("Verification link expired");
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(errorMessages(message));
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message;
    toast.error(errorMessage);
  }
};

export const RgenerateToken = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: `${url}${data}` });
  if (
    (myJson && myJson?.data?.statusCode === 200) ||
    myJson?.data?.statusCode === 201
  ) {
    const { data } = myJson;
    if (data?.statusCode === 200) {
      toast.success(
        data.message ||
        "New token has been generated. Please Check the email for verification"
      );
      return data?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};

export const updatePasswordAPI = async (method, url, token, data, navigate) => {
  const myJson = await apiCaller({ method, url: `${url}${token}`, data });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200 || myJson?.data?.statusCode === 201)
  ) {
    logOut();
    setCookie("permissions", "");
    toast.success(myJson?.data?.message || "Password updated successfully.");
    navigate("/login", { replace: true });
    return myJson?.data;
  }
  const { message } = messsageStatusResponse(myJson);
  toast.error(errorMessages(message));
};

export const UplaodingFile = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: url, data });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
  ) {
    const { data } = myJson;
    const message = myJson?.response?.data?.message;
    if (myJson?.data && apiCallFor === "uploadCSV") {
      toast.success(message);
      return myJson?.data;
    } else {
      toast.success(message);
      return data?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};

export const logoutAPI = (method, url, apiCallFor) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url: url });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
    }
  };
};

export const getAllUserTypes = (method, url, apiCallFor) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      const { data } = myJson?.data;
      dispatch(UserTypesAction(data));
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(errorMessages(message));
      dispatch(
        ApiRejectedAction({ statusCode, apiCallFor: apiCallFor, message })
      );
    }
  };
};

export const CheckSpeechAPI = (method, url, data, apiCallFor, navigate) => {
  return async (dispatch) => {
    dispatch(ApiRequestedAction({ apiCallFor }));
    const myJson = await apiCaller({ method, url: url, data });
    if (
      myJson &&
      (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
    ) {
      dispatch(ApiFulfilledAction({ apiCallFor: apiCallFor, message: "" }));
      toast.success(myJson?.data.message);
      return myJson?.data;
    } else {
      const { message, statusCode } = messsageStatusResponse(myJson)
      toast.error(
        errorMessages(Array.isArray(message) ? message.join(", ") : message)
      );
      dispatch(
        ApiRejectedAction({
          statusCode,
          apiCallFor: apiCallFor,
          message,
        })
      );
    }
  };
};

export const ChangeStatus = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: url, data });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
  ) {
    const { data } = myJson;
    if (data?.data) {
      toast.success(data.message);
      return myJson?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};

export const AssignStatus = async (method, url, data, apiCallFor) => {
  const myJson = await apiCaller({ method, url: url, data });
  if (
    myJson &&
    (myJson?.data?.statusCode === 200) | (myJson?.data?.statusCode === 201)
  ) {
    const { data } = myJson;
    if (data?.data) {
      toast.success(data.message);
      return myJson?.data;
    }
  } else {
    const { message, statusCode } = messsageStatusResponse(myJson)
    toast.error(errorMessages(message));
  }
};
